import { Outlet } from "react-router-dom";
import { useState, ReactNode } from "react";
import { AuthModal } from "../../../../src/components/AuthModal";
import {
  Sidebar,
  SidebarContent,
  SidebarMenu,
  SidebarMenuItem,
  SidebarMenuButton,
  SidebarProvider,
} from "../ui/sidebar";
import {
  Home,
  Briefcase,
  Users,
  Mail,
  UserRoundPen,
  MessageCircleHeart,
  CalendarDays,
  BadgeDollarSign,
} from "lucide-react";
import { User } from "../../../../src/types";

interface DashboardLayoutProps {
  user: User | null;
  signOut: () => void;
  children?: ReactNode;
}

export const DashboardLayout: React.FC<DashboardLayoutProps> = ({
  user,
  signOut,
  children,
}) => {
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [initialAuthTab, setInitialAuthTab] = useState<"signin" | "signup">(
    "signin"
  );

  const navLinks = [
    { name: "Dashboard", href: "/", icon: Home },
    { name: "Profile", href: "/profile", icon: UserRoundPen },
    {
      name: "Event Marquee",
      href: "/startup-spark-suite/events",
      icon: CalendarDays,
    },
    {
      name: "Startup Social",
      href: "/startup-social",
      icon: MessageCircleHeart,
    },
    { name: "Pricing", href: "/pricing", icon: BadgeDollarSign },
    { name: "Contact Us", href: "/ContactUs", icon: Mail },
  ];

  return (
    <div>
      {showAuthModal && (
        <AuthModal
          onClose={() => setShowAuthModal(false)}
          initialTab={initialAuthTab}
        />
      )}
      <main className="p-4 lg:p-6">
        {/* This div will be our flex container for sidebar and content */}
        <div className="flex">
          {/* Sidebar Column */}
          {/* Sidebar Column - only render on large screens */}
          <div className="hidden lg:block w-64 flex-shrink-0">
            <SidebarProvider>
              <Sidebar>
                <SidebarContent>
                  <SidebarMenu className="py-24">
                    {navLinks.map((link) => (
                      <SidebarMenuItem key={link.name}>
                        <SidebarMenuButton asChild>
                          <a
                            href={link.href}
                            className="flex items-center space-x-2 font-bold text-lg"
                          >
                            {link.icon && <link.icon className="h-5 w-5" />}
                            <span>{link.name}</span>
                          </a>
                        </SidebarMenuButton>
                      </SidebarMenuItem>
                    ))}
                  </SidebarMenu>
                </SidebarContent>
              </Sidebar>
            </SidebarProvider>
          </div>

          {/* Main Content Column */}
          <div className="flex-1">
            {" "}
            {/* Takes remaining space */}
            {children || <Outlet />}
          </div>
        </div>
      </main>
    </div>
  );
};
